import { redirect, createFileRoute } from '@tanstack/react-router';
import { LoginForm } from '@/pages/auth/login/LoginForm';
import { SIGNUP_DETAILS_ROUTE, isSignupIncomplete } from '@/lib/incomplete-signup';
import { z } from 'zod';
import { appOriginUrlForCurrentPage } from '@/pages/auth/social/socialOrigin';
import { captureAuthorizeQuery } from '@/lib/oauth/oauth-flow';

export const Route = createFileRoute('/login')({
	validateSearch: z.object({
		redirect: z.string().optional(),
		// Carried by the signup screens' "log in instead" links so the form knows the address.
		email: z.string().optional(),
	}),
	beforeLoad: ({ context, location }) => {
		// A tenant host cannot open any provider (`social/socialOrigin.ts`), so the page moves first.
		const appOriginUrl = appOriginUrlForCurrentPage();
		if (appOriginUrl) throw redirect({ href: appOriginUrl });
		const continuation = captureAuthorizeQuery({ search: location.searchStr });
		const { authenticated, user } = context.globalStore.getState();
		if (!authenticated) return;
		// A social tap signs the User in before the signup is finished; they own one screen until
		// they submit it, and the login page is not it.
		if (isSignupIncomplete(user)) throw redirect(SIGNUP_DETAILS_ROUTE);
		if (continuation.kind === 'valid') throw redirect({ to: '/oauth/resume' });
		throw redirect({ to: '/' });
	},
	component: LoginForm,
});
